<template>
  <div class="social-media-label"
       @click="$emit('click')">
    <div class="header">
      <icon-gear height="14"
                 width="14" />

      {{ $t("socialMedia.manageIn") }}
    </div>

    <div class="body">
      {{ $t("socialMedia.title3") }}
    </div>
  </div>
</template>

<script>
  export default {

  }
</script>

<style lang="scss" scoped>
  .social-media-label {
    height: 44px;
    width: 150px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    color: map-get($colors, primary);
    background: rgba(128, 103, 183, .15);
    border-radius: 20px;

    font-size: 10px;
    text-transform: uppercase;
    cursor: pointer;

    .header {
      width: 50%;

      display: flex;
      justify-content: space-between;
      align-items: center;

      margin-bottom: 4px;
      opacity: .5;
    }
  }
</style>